var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCupom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8501 0.850098C2.64096 0.850098 0.850098 2.64096 0.850098 4.8501V8.8501C0.850098 11.0592 2.64096 12.8501 4.8501 12.8501H12.8501C15.0592 12.8501 16.8501 11.0592 16.8501 8.8501C15.7455 8.8501 14.8501 7.95467 14.8501 6.8501C14.8501 5.74553 15.7455 4.8501 16.8501 4.8501C16.8501 2.64096 15.0592 0.850098 12.8501 0.850098H4.8501Z",
    fill: "#FAE6E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.85 1.7C3.1103 1.7 1.7 3.1103 1.7 4.85V8.85C1.7 10.5897 3.1103 12 4.85 12H12.85C14.3506 12 15.6061 10.9507 15.9229 9.54581C14.804 9.1611 14 8.09944 14 6.85C14 5.60056 14.804 4.5389 15.9229 4.15419C15.6061 2.7493 14.3506 1.7 12.85 1.7H4.85ZM0 4.85C0 2.17142 2.17142 0 4.85 0H12.85C15.5286 0 17.7 2.17142 17.7 4.85C17.7 5.31944 17.3194 5.7 16.85 5.7C16.2149 5.7 15.7 6.21487 15.7 6.85C15.7 7.48513 16.2149 8 16.85 8C17.3194 8 17.7 8.38056 17.7 8.85C17.7 11.5286 15.5286 13.7 12.85 13.7H4.85C2.17142 13.7 0 11.5286 0 8.85V4.85Z",
    fill: "#A51713"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.55 0.850098C11.9366 0.850098 12.25 1.1635 12.25 1.5501L12.25 4.1501C12.25 4.5367 11.9366 4.8501 11.55 4.8501C11.1634 4.8501 10.85 4.5367 10.85 4.1501L10.85 1.5501C10.85 1.1635 11.1634 0.850098 11.55 0.850098Z",
    fill: "#A51713"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.55 8.8501C11.9366 8.8501 12.25 9.1635 12.25 9.5501L12.25 12.1501C12.25 12.5367 11.9366 12.8501 11.55 12.8501C11.1634 12.8501 10.85 12.5367 10.85 12.1501L10.85 9.5501C10.85 9.1635 11.1634 8.8501 11.55 8.8501Z",
    fill: "#A51713"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.55 5.8501C11.9366 5.8501 12.25 6.1635 12.25 6.5501L12.25 7.1501C12.25 7.5367 11.9366 7.8501 11.55 7.8501C11.1634 7.8501 10.85 7.5367 10.85 7.1501L10.85 6.5501C10.85 6.1635 11.1634 5.8501 11.55 5.8501Z",
    fill: "#A51713"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCupom);
export default __webpack_public_path__ + "static/media/icon_cupom.55723caf51fa058d0a6007ba1c6496bb.svg";
export { ForwardRef as ReactComponent };